<template>
  <v-toolbar-title>
    <!--<template class="d-flex d-sm-none">今日趋势</template>-->
    <v-tooltip bottom>
      <template v-slot:activator="{on, attrs}">
        <v-badge :content="stat.orders - stat.oldOrders" offset-x="10%" offset-y="45%" color="red" overlap :value="stat.orders - stat.oldOrders > 0">
          <v-chip class="ma-2" color="primary" v-on="on" v-bind="attrs">
            {{ counts.countOrders }} (昨: {{ counts.countLastDayCurrentlyOrders }} / {{ counts.countLastDayOrders }})
          </v-chip>
        </v-badge>
      </template>
      <span>{{ statFormat }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{on, attrs}">
        <v-badge :content="stat.sales - stat.oldSales" offset-x="10%" offset-y="45%" color="red" overlap :value="stat.sales - stat.oldSales > 0">
          <v-chip class="ma-2" color="indigo" text-color="white" v-on="on" v-bind="attrs">
            {{ counts.countSales }} (昨: {{ counts.countLastDayCurrentlySales }} / {{ counts.countLastDaySales }})
          </v-chip>
        </v-badge>
      </template>
      <span>{{ statFormat }}</span>
    </v-tooltip>
    <!--<v-chip class="ma-2" color="green" text-color="white">
      已付款: {{ counts.countPayed }} (昨: {{counts.countLastDayCurrentlyPayed}} / {{counts.countLastDayPayed}})
    </v-chip>
    <v-chip class="ma-2">
      已取消: {{ counts.countCanceled }} (昨: {{counts.countLastDayCurrentlyCanceled}} / {{counts.countLastDayCanceled}})
    </v-chip>-->
  </v-toolbar-title>
</template>

<script>
export default {
  name: "Statistics",
  props: {
    params: null,
    selectedTimer: {
      type: String
    }
  },
  computed: {
    statFormat() {
      if (this.stat.oldLogTime) {
        return this.$format("上次记录: {} ({}时{}分), 前: {}/{}, 现: {}/{}, 增: {}/{}",
            this.getTimeDiff, this.stat.oldLogTime.getHours(), this.stat.oldLogTime.getMinutes(),
            this.stat.oldOrders, this.stat.oldSales,
            this.stat.orders, this.stat.sales,
            this.stat.orders - this.stat.oldOrders, this.stat.sales - this.stat.oldSales);
      } else {
        return "";
      }
    }, getTimeDiff() {
      if (this.stat.oldLogTime && this.stat.logTime) {
        let oldTime = this.stat.oldLogTime.getTime();
        let newTime = this.stat.logTime.getTime();

        let hour = (newTime - oldTime) / 1000 / 60 / 60;
        let min = (newTime - oldTime) / 1000 / 60;

        if (hour > 1) {
          return this.$format("{}小时{}分钟前", parseInt(hour), parseInt(min));
        } else if (min > 1) {
          return this.$format("{}分钟前", parseInt(min));
        } else {
          return "1分钟内";
        }
      }

      return "";
    }
  },
  data() {
    return {
      counts: {},
      stat: {
        oldOrders: null,
        oldSales: null,
        oldLogTime: null,
        oldParams: null,
        orders: null,
        sales: null,
        logTime: null,
        params: null
      }
    }
  }, methods: {
    getData() {
      this.$axios.post("/products/today/count", this.params).then(
          response => {
            if (response.data) {
              this.counts = response.data;
              this.calcData();
            }
          }
      );
    },
    calcData() {
      let lastStat;
      let lastStatStr = localStorage.getItem("lastStat");
      let curTime = new Date();
      // 只有上次保存的时间为同一天, 才提取上次的数据进行对比
      if (lastStatStr) {
        lastStat = JSON.parse(lastStatStr);
        let logTime = new Date(lastStat.logTime);
        if (logTime.getFullYear() === curTime.getFullYear()
            && logTime.getMonth() === curTime.getMonth()
            && logTime.getDate() === curTime.getDate()) {
          console.debug("上次的数据为同一天的数据, 保存下来进行对比: ", lastStat);
          this.stat.oldOrders = lastStat.orders;
          this.stat.oldSales = lastStat.sales;
          this.stat.oldLogTime = logTime;
        } else {
          console.debug("上次的数据不是同一天的数据, 直接用最新的数据.");
          this.stat.oldOrders = this.counts.countOrders;
          this.stat.oldSales = this.counts.countSales;
          this.stat.oldLogTime = curTime;
        }
      } else {
        console.debug("没有之前的数据, 直接用最新的数据.");
        this.stat.oldOrders = this.counts.countOrders;
        this.stat.oldSales = this.counts.countSales;
        this.stat.oldLogTime = curTime;
      }

      this.stat.orders = this.counts.countOrders;
      this.stat.sales = this.counts.countSales;
      this.stat.logTime = curTime;


      console.debug("保存数据: ", this.stat);
      localStorage.setItem("lastStat", JSON.stringify(this.stat));
    },
    reset() {
      this.counts = {
        countOrders: 0,
        countSales: 0,
        // countPayed: 0,
        // countCanceled: 0,
        countLastDayOrders: 0,
        countLastDaySales: 0,
        // countLastDayPayed: 0,
        // countLastDayCanceled: 0,
        countLastDayCurrentlyOrders: 0,
        countLastDayCurrentlySales: 0,
        // countLastDayCurrentlyPayed: 0,
        // countLastDayCurrentlyCanceled: 0
      }
    },
    clear() {
      console.debug("我死得好惨啊!");
      localStorage.removeItem("lastStat");
    }
  }, mounted() {
    /*this.reset();
    this.getData();*/
    this.$bus.$on("updateStat", () => {
      this.reset();
      this.getData();
    });
    this.$bus.$on("clearStat", this.clear);
  }, beforeDestroy() {
    this.$bus.$off("updateStat");
    this.$bus.$off("clearStat");
  }
}
</script>

<style scoped>
.v-toolbar__title{
  padding-right: 10px
}
</style>